import { useContext, useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { setSessionExpiredHandler } from "./configs/axios.config";
import { AuthContext } from "./contexts/AuthContext";
import ScreenSizeChecker from "./pages/components/ScreenSizeChecker";
import AppRoutes from "./routes/appRoutes";
import { userService } from "./services/api/authenService";

function App() {
  const { dispatch } = useContext(AuthContext);
  const [isSessionExpired, setSessionExpired] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1200);

  const handleLogout = async () => {
    try {
      await userService.log_out();
      dispatch({ type: "LOGOUT" });
      toast.success("Đăng xuất thành công!");
      window.location.href = "/login";
    } catch (error) {
      // Nếu logout API thất bại, vẫn logout phía client
      dispatch({ type: "LOGOUT" });

      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng.",
      );

      console.error("Error:", error);

      // Vẫn redirect về login
      window.location.href = "/login";
    }
  };

  useEffect(() => {
    // CHỈ set handler, KHÔNG tự động gọi
    setSessionExpiredHandler(() => {
      console.log("Session expired modal triggered");
      setSessionExpired(true);
    });
  }, []);

  // Xử lý khi session expired
  useEffect(() => {
    if (isSessionExpired) {
      toast.error("Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.");
      // Đợi 1.5s để user đọc toast
      setTimeout(() => {
        handleLogout();
      }, 1500);
    }
  }, [isSessionExpired]);

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        theme="light"
        style={{ zIndex: 99999 }}
      />

      <ScreenSizeChecker onScreenSizeChange={setIsSmallScreen} />

      {isSmallScreen ? null : <AppRoutes />}
    </>
  );
}

export default App;
